<template>
  <div class="c-widget-eform" ref="content">
    <message type="error" v-if="isAdmin && isEmbed && currentSurvey.private">
      <h4>Survey is private</h4>
      <p>
        This survey has been marked as private, but has been embedded onto the
        page. This means that some users may not be able to access the survey.
        Please be sure that this survey is set up correctly.
      </p>
    </message>
    <media-resource v-bind="$props" v-if="!isEmbed" is-link />
    <section v-if="isEmbed">
      <loading v-if="!loaded" />
      <div
        v-if="
          currentSurvey.private &&
            (currentSurvey.created_user.id !== userId && !userInvited) &&
            !isAdmin
        "
      >
        <h1>Survey is private</h1>

        <p>You are not able to view this survey</p>
      </div>
      <div v-else>
        <h2>{{ title }}</h2>
        <form-builder-form :form="currentSurvey" type="survey" />
      </div>
    </section>
  </div>
</template>

<script>
import FormBuilderForm from "@/components/FormBuilderForm";
import { mapState } from "vuex";
/**
 * Display an eform, either embedded on the page or just a link
 * Need to disable embed on admin
 */
export default {
  components: {
    FormBuilderForm,
  },
  props: ["resourceLink", "display", "title"],
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    if (this.display == "embed") {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      };

      const observer = new IntersectionObserver(this.onVisible, options);
      observer.observe(this.$refs.content);
    }
  },
  methods: {
    async onVisible(entries, observer) {
      const entryToCheck = entries[0];
      if (entryToCheck.isIntersecting && !this.loaded) {
        try {
          await this.$store.dispatch(
            "Surveys/retrieveByUrl",
            JSON.parse(this.resourceLink).id.replace("/survey", "")
          );
        } catch (err) {
          console.log(
            "TCL:  ~ file: MediaEform.vue ~ line 67 ~ onVisible ~ err",
            err
          );
        }
        this.loaded = true;
        console.log(
          "TCL:  ~ file: MediaEform.vue ~ line 39 ~ onVisible ~ entryToCheck",
          entryToCheck
        );
      }
    },
  },
  computed: {
    ...mapState("Surveys", ["currentSurvey"]),
    isAdmin() {
      return this.$route.meta.isAdmin;
    },
    isEmbed() {
      return this.display == "embed";
    },
    userInvited() {
      if (!this.currentSurvey.users) {
        return false;
      }
      const users = this.currentSurvey.users.filter(
        (user) => user.id == this.$store.state.auth.currentUser.id
      );

      return users && users.length;
    },
    userId() {
      if (!this.$store.state.auth.currentUser.id) {
        this.$store.dispatch("auth/listCurrentUser").then((resp) => {
          return this.$store.state.auth.currentUser.id;
        });
      } else {
        return this.$store.state.auth.currentUser.id;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
